(() => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  const heroMedia = document.querySelector(".men-luxury__hero-media");
  const sections = document.querySelectorAll("[data-animate='section']");
  const groups = document.querySelectorAll("[data-animate='group']");

  if (!sections.length && !groups.length) {
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      }
    },
    {
      root: null,
      threshold: 0.18,
      rootMargin: "0px 0px -10% 0px",
    }
  );

  for (const section of sections) observer.observe(section);
  for (const group of groups) observer.observe(group);

  // Subtle premium depth effect on hero while scrolling.
  if (heroMedia) {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const offset = Math.min(window.scrollY * 0.06, 28);
        heroMedia.style.transform = `scale(1.05) translateY(${offset}px)`;
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  // Hide header on scroll down, show on scroll up
  const header = document.querySelector('#header-component');
  if (header) {
    let lastScroll = 0;
    
    const handleHeaderScroll = () => {
      const currentScroll = window.scrollY;
      
      if (currentScroll <= 0) {
        header.style.transform = 'translateY(0)';
        return;
      }
      
      if (currentScroll > lastScroll && currentScroll > 120) {
        // Scrolling down
        header.style.transform = 'translateY(-100%)';
      } else {
        // Scrolling up
        header.style.transform = 'translateY(0)';
      }
      
      lastScroll = currentScroll;
    };
    
    window.addEventListener('scroll', handleHeaderScroll, { passive: true });
  }

  // Floating scroll indicator that fades out on scroll
  const scrollIndicator = document.getElementById('scrollIndicator');
  if (scrollIndicator) {
    const handleScrollIndicator = () => {
      const scrolled = window.scrollY;
      if (scrolled > 100) {
        scrollIndicator.classList.add('scroll-indicator--hidden');
      } else {
        scrollIndicator.classList.remove('scroll-indicator--hidden');
      }
    };
    
    window.addEventListener('scroll', handleScrollIndicator, { passive: true });
    handleScrollIndicator();
  }
})();
